import axios from 'axios';
import { config } from './config';

// Créer une instance axios avec la configuration de base
const api = axios.create({
    baseURL: `${config.baseUrl}${config.apiBase}`,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Intercepteur de requête pour ajouter automatiquement le token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Intercepteur de réponse pour gérer les erreurs d'authentification
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Token invalide ou expiré
            localStorage.removeItem("token");
            localStorage.removeItem("idUser");
            // Rediriger vers la page de login si nécessaire
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default api;

